var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoWarning = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32799_122711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.8598 14 14 10.8598 14 7C14 3.1402 10.8598 -3.37434e-07 7 0C3.1402 3.37434e-07 -3.37434e-07 3.1402 0 7C3.37434e-07 10.8598 3.1402 14 7 14ZM7.7 9.8C7.7 10.1866 7.3866 10.5 7 10.5C6.6134 10.5 6.3 10.1866 6.3 9.8V7C6.3 6.6134 6.6134 6.3 7 6.3C7.3866 6.3 7.7 6.6134 7.7 7V9.8ZM7 3.5C6.6134 3.5 6.3 3.8134 6.3 4.2C6.3 4.5866 6.6134 4.9 7 4.9C7.3866 4.9 7.7 4.5866 7.7 4.2C7.7 3.8134 7.3866 3.5 7 3.5Z",
    fill: "#D72C0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32799_122711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-warning.9d4a45b9.svg";
export { ForwardRef as ReactComponent };